import { ITestimonialsResponse } from 'components/TestimonialsCarousel/TestimonialsCarousel.types'
import BaseBridge from 'config/bridge/BaseBridge'
import BaseService from 'config/bridge/BaseService'
import { BridgeMockUserInfo } from 'config/bridge/BridgeMock'

export default class TestimonialsService {
  static async getTestimonials(): Promise<ITestimonialsResponse> {
    let headers = {}

    if (BaseBridge.isBrowser()) {
      headers = {
        'x-inter-user-bank-account': BridgeMockUserInfo.account,
      }
    }

    const response = await BaseService.doExecute<ITestimonialsResponse>({
      method: 'GET',
      endpoint: `${process.env.REACT_APP_API_CAPITALIZATION}/testimonials`,
      headers,
    })

    return response.data
  }
}
